import { createTheme } from '@material-ui/core';

export const themeOptions = {
  typography: {
    fontFamily: 'Inter, Roboto, sans-serif !important',
    h1: {
      fontWeight: 700,
      fontSize: '2.2rem',
      marginTop: '15px',
      marginBottom: '20px',
    },
    h2: {
      fontWeight: 700,
      fontSize: '2rem',
      marginTop: '15px',
      marginBottom: '20px',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.8rem',
      marginTop: '15px',
      marginBottom: '20px',
    },
    h4: {
      fontWeight: 500,
      fontSize: '1.6rem',
      marginTop: '15px',
      marginBottom: '20px',
    },
    h5: {
      fontSize: '1.4rem',
      marginTop: '15px',
      marginBottom: '20px',
    },
    h6: {
      fontSize: '1rem',
      marginTop: '15px',
      marginBottom: '20px',
    },
    body1: {
      color: '#060B2B',
      marginBottom: '15px',
    },
  },
  palette: {
    background: {
      default: '#EBF4F8',
    },
    primary: {
      main: '#1e38ea',
    },
    green: {
      main: '#388e3c',
    },
    error: {
      main: '#f44336',
    },
  },
  props: {
    MuiRadio: {
      color: 'primary',
    },
    MuiButton: {
      variant: 'contained',
      color: 'primary',
    },
    MuiCheckbox: {
      color: 'primary',
    },
    MuiTabs: {
      className: 'tabs',
      textColor: 'primary',
      indicatorColor: 'primary',
    },
    MuiSwitch: {
      color: 'primary',
    },
    MuiPagination: {
      color: 'primary',
    },
  },
  overrides: {
    MuiInputBase: {
      root: {
        marginBottom: '4px',
        fontFamily: 'Inter, Roboto, sans-serif !important',
      },
    },
    MuiOutlinedInput: {
      root: {
        fontFamily: 'Inter, Roboto, sans-serif !important',
      },
    },
    MuiSelect: {
      root: {
        fontFamily: 'Inter, Roboto, sans-serif !important',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'initial',
        fontFamily: 'Inter, Roboto, sans-serif !important',
      },
    },
    MuiButtonBase: {
      root: {
        fontFamily: 'Inter, Roboto, sans-serif !important',
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: '10px',
      },
      elevation1: {
        boxShadow: 'rgb(12 26 75 / 24%) 0px 0px 1px, rgb(50 50 71 / 5%) 0px 3px 8px -1px',
        borderRadius: '16px',
      },
      elevation8: {
        boxShadow: '0px 12px 16px -4px rgb(16 24 40 / 8%), 0px 4px 6px -2px rgb(16 24 40 / 3%)',
      },
      elevation9: {
        boxShadow: '0 0.5rem 2rem rgb(0 0 0 / 11%), 0 3px 10px rgb(0 0 0 / 5%), 0 2px 3px rgb(0 0 0 / 6%)',
      },
    },
    MuiIconButton: {
      root: {
        color: '#515151',
        borderRadius: 0,
        borderBottom: '1px solid transparent',
        '&:hover': {
          borderBottom: '1px solid #1e38ea',
        },
      },
    },
    MuiTooltip: {
      tooltipArrow: {
        backgroundColor: '#000!important',
        textAlign: 'center',
        fontSize: '12px!important',
        color: '#f1f5f8',
        padding: '4px 10px',
        borderRadius: '4px',
        fontWeight: '500',
        letterSpacing: '0px',
        fontFamily: 'Inter, Roboto, sans-serif !important',
      },
      arrow: {
        '&::before': {
          color: '#000',
        },
      },
    },
    MuiTabs: {
      indicator: {
        borderTopLeftRadius: '3px',
        borderTopRightRadius: '3px',
        height: '4px',
      },
    },
    MuiTab: {
      root: {
        margin: '0 0px 0 0',
        padding: '0 15px',
        fontFamily: 'Inter, Roboto, sans-serif !important',
      },
    },
  },
};

export default createTheme(themeOptions);
